import { render } from "./AddDeleteButtons.vue?vue&type=template&id=28604b1d&ts=true"
import script from "./AddDeleteButtons.vue?vue&type=script&lang=ts"
export * from "./AddDeleteButtons.vue?vue&type=script&lang=ts"

import "./AddDeleteButtons.vue?vue&type=style&index=0&id=28604b1d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__